import { Component } from '@angular/core';

import { AuthorizationService } from '../../../shared/index';

@Component({
    selector: 'pmdocument-index',
    templateUrl: './pmdocument-index.html',
    standalone: false
})

export class PMDocumentIndexComponent {
    constructor(
        private _authorizationService: AuthorizationService,
    ) { }

}
